import { render, staticRenderFns } from "./MovilComponent.vue?vue&type=template&id=082e1be0&scoped=true&"
import script from "./MovilComponent.vue?vue&type=script&lang=js&"
export * from "./MovilComponent.vue?vue&type=script&lang=js&"
import style0 from "./MovilComponent.vue?vue&type=style&index=0&id=082e1be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e1be0",
  null
  
)

export default component.exports